ux-iws-comparison-matrix {
    display: block;
    --group-column-width: 180px;
    --ux-input-label-padding: 0 0 10px 0;

    .ux-iws-comparison-matrix__header {
        text-align: center;
    }

    .ux-iws-comparison-matrix__table {
        width: 100%;
        display: none;

        &--active {
            display: block;
        }
    }

    .ux-iws-comparison-matrix__table-legend {
        @include font("bold");
        display: flex;
        flex-flow: row nowrap;
        align-items: flex-start;
        justify-content: flex-start;
        width: 100%;
        border-bottom: 1px solid $color-gray-borders;

        > div {
            flex: 0 0 auto;
            padding: 15px 30px;
            font-size: 0.75rem;
            text-transform: uppercase;
            color: $color-black;
        }

        > div:first-child {
            width: var(--group-column-width, auto);
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    /* needed to override explicit ux-table styles */
    /* stylelint-disable selector-max-compound-selectors */
    .ux-table {
        table {
            outline: 0 none transparent;
            width: 100%;
        }

        table:focus-visible {
            outline: var(--ux-input-outline-width) solid
                var(--ux-button-focus-border-color);
            outline-offset: var(--ux-input-outline-offset);
        }

        thead th {
            padding: 15px 30px;
            text-align: left;
            background-color: $color-white;
            border: 0 none;
        }

        tbody td,
        tbody th {
            padding: 30px;
            border: 0 none;
            text-transform: none;
        }

        tbody td ux-icon {
            font-size: 20px;
        }

        tbody th,
        tbody td:first-child {
            @include font("bold");
            font-size: 13px;
            min-width: var(--group-column-width, auto) !important;
            max-width: var(--group-column-width, auto);
            width: var(--group-column-width, auto);
        }

        tbody tr:nth-child(odd) td,
        tbody tr:nth-child(odd) th {
            background-color: $color-gray-background;
        }

        tbody tr:nth-child(even) td,
        tbody tr:nth-child(even) th {
            background-color: $color-white;
        }
    }

    .ux-table--is-fixed {
        thead th:nth-child(1),
        tbody th:nth-child(1) {
            border-right: 1px solid $color-black-4 !important;
            margin: 0 !important;
        }
    }
    /* stylelint-enable selector-max-compound-selectors */
}
